import React, { useEffect, useRef, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import SearchFilter from "assets/Icons/SearchFilter.svg";
import Line from "assets/Icons/Line.svg";

import {
  Box,
  FormControlLabel,
  FormGroup,
  Input,
  InputAdornment,
  Paper,
  Radio,
  Stack,
  Typography,
} from "@mui/material";
import { SellersProps } from "../types";
import { useDispatch, useSelector } from "react-redux";
import { addSelectedSellers } from "store/auth/auth.slice";
import { AppState } from "store/types";
import TableFilter from "../TableFilter";
import { addFilters, updateFilters } from "store/table/table.slice";
import NotificationDot from "assets/Icons/NotificationDot";
import { changePaymentsSeller } from "store/payments/payments.slice";
import BootstrapTooltip from "components/ToolTips/BootstrapTooltip";
import _ from "lodash";

const SellerFilter = ({
  disableMultiple = false,
  disableFilter = false,
  placeholder,
}: {
  disableMultiple?: boolean;
  disableFilter?: boolean;
  placeholder?: string;
}) => {
  const selectedSellers = useSelector(
    (state: AppState) => state.auth.selectedSellers
  );

  const filters = useSelector((state: AppState) => state.table.columnFilters);

  const dispatch = useDispatch();
  const ref = useRef();
  const tableFilterRef = useRef();
  const [sellers, setSellers] = useState<SellersProps[]>(selectedSellers);
  const [open, setOpen] = useState<boolean>(false);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [text, setText] = useState<string>("");

  useEffect(() => {
    if (
      selectedSellers.every(
        (item: SellersProps) =>
          !item.checked ||
          selectedSellers.some((item: SellersProps) => item.checked)
      )
    ) {
      setSelectAll(false);
    }
    if (selectedSellers.every((item: SellersProps) => item.checked)) {
      setSelectAll(true);
    }
  }, [selectedSellers]);

  const handleChangeSellers = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;

    if (name === "selectAll") {
      setSelectAll(!selectAll);
      const updatedSellers = sellers.map((item: SellersProps) => {
        return { ...item, checked: !selectAll };
      });

      setSellers(updatedSellers);
    } else {
      const updatedSellers = sellers.map((item: SellersProps) => {
        if (item.id === name) {
          return { ...item, checked: !item.checked };
        } else if (disableMultiple) {
          return { ...item, checked: false };
        } else return item;
      });

      setSellers(updatedSellers);
    }
  };

  const handleChangeSingleSellers = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const name = e.target.name;

    const updatedSellers = sellers.map((item: SellersProps) => {
      if (item.id === name) {
        return { ...item, checked: !item.checked };
      } else return { ...item, checked: false };
    });

    setSellers(updatedSellers);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  const handleOpenFilter = () => {
    setOpen(false);
    setOpenFilter(!openFilter);
  };
  const handleCloseFilter = () => setOpenFilter(false);

  useEffect(() => {
    if (selectedSellers && selectedSellers.length) setSellers(selectedSellers);
  }, [selectedSellers]);

  const handleApplySellerFilter = () => {
    const filterSellers = sellers
      .filter((item: SellersProps) => {
        if (item.checked) return item;
      })
      .map((item: SellersProps) => item.id);
    dispatch(addSelectedSellers(sellers));
    dispatch(changePaymentsSeller(filterSellers[0]));
    if (_.isEmpty(filters)) dispatch(addFilters(["seller_id", filterSellers]));
    else {
      dispatch(updateFilters(["seller_id", filterSellers]));
    }

    setOpen(false);
  };

  const handleClick = (name: string) => {
    const updatedSellers = sellers.map((item: SellersProps) => {
      if (item.id === name) {
        return { ...item, checked: true };
      } else return item;
    });

    setSellers(updatedSellers);
    setText(name);
  };

  useEffect(() => {
    const handler = (e: any) => {
      //@ts-ignore
      if (!ref?.current?.contains(e?.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  return (
    <Box ref={ref}>
      <Input
        onFocus={() => {
          setOpen(true);
          setOpenFilter(false);
        }}
        ref={ref}
        placeholder={placeholder ? placeholder : "Search"}
        value={text}
        type="text"
        onChange={handleChange}
        disableUnderline
        style={{
          background: "white",
          height: "48px",
          margin: "0 10px 0 0",
          width: "272px",
          borderRadius: "8px",
          border: "1px solid #D0D5DD",
          cursor: "pointer",
          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
          padding: "0 12px",
          fontFamily: "Lato",
          fontSize: "16px",
          fontWeight: 400,
          textDecoration: "none",
        }}
        endAdornment={
          !disableFilter && (
            <InputAdornment position="end" sx={{ position: "relative" }}>
              <Box
                sx={{
                  width: "30px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <img src={Line} alt="line" />
                {filters &&
                  filters?.length > 0 &&
                  filters[0] !== "seller_id" && <NotificationDot />}
                {filters &&
                filters?.length > 0 &&
                filters[0] !== "seller_id" ? (
                  <BootstrapTooltip
                    placement="bottom-start"
                    open
                    title={`Filter applied : ${filters[0]} = ${filters[1]}`}
                    sx={{
                      zIndex: 2,
                    }}
                  >
                    <img
                      src={SearchFilter}
                      alt="filter"
                      onClick={handleOpenFilter}
                    />
                  </BootstrapTooltip>
                ) : (
                  <img
                    src={SearchFilter}
                    alt="filter"
                    onClick={handleOpenFilter}
                  />
                )}
              </Box>
            </InputAdornment>
          )
        }
      />

      {open && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            position: "absolute",
            zIndex: 100,
          }}
        >
          <Paper
            elevation={2}
            sx={{
              width: "241px",
              padding: "16px",
              borderRadius: "8px",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "12px",
                display: "flex",
                alignItems: "center",
                color: "#757575",
              }}
            >
              Sellers
            </Typography>
            <FormGroup>
              <ul
                style={{
                  listStyle: "none",
                  padding: "0px",
                  maxHeight: "300px",
                  overflowY: "scroll",
                }}
              >
                {!disableMultiple && (
                  <li key={-1}>
                    <FormControlLabel
                      sx={{
                        fontFamily: "Lato",
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#424242",
                      }}
                      control={
                        <Checkbox
                          size="small"
                          name={"selectAll"}
                          checked={selectAll}
                          sx={{
                            fontFamily: "Lato",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "#424242",
                          }}
                          onChange={handleChangeSellers}
                        />
                      }
                      label={"Select All"}
                    />
                  </li>
                )}
                {sellers
                  .filter((item: SellersProps) => {
                    if (item?.name?.toLowerCase().includes(text.toLowerCase()))
                      return item;
                  })
                  .map((item) => (
                    <li key={item.id}>
                      <FormControlLabel
                        sx={{
                          fontFamily: "Lato",
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "#424242",
                        }}
                        control={
                          !disableMultiple ? (
                            <Checkbox
                              size="small"
                              name={item.id}
                              checked={item.checked}
                              sx={{
                                fontFamily: "Lato",
                                fontSize: "16px",
                                fontWeight: "400",
                                color: "#424242",
                              }}
                              onChange={handleChangeSellers}
                            />
                          ) : (
                            <Radio
                              size="small"
                              name={item.id}
                              checked={item.checked}
                              sx={{
                                fontFamily: "Lato",
                                fontSize: "16px",
                                fontWeight: "400",
                                color: "#424242",
                              }}
                              onChange={handleChangeSellers}
                            />
                          )
                        }
                        label={item.name}
                      />
                      {/* )} */}
                    </li>
                  ))}
              </ul>
            </FormGroup>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "16px",
                  color: "#01579B",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "16px",
                  color: "#01579B",
                  cursor: "pointer",
                }}
                onClick={handleApplySellerFilter}
              >
                Apply
              </Typography>
            </Box>
          </Paper>
        </Stack>
      )}

      {openFilter ? (
        <Box ref={tableFilterRef}>
          <TableFilter handleClose={handleCloseFilter} text={text} />
        </Box>
      ) : null}
    </Box>
  );
};

export default SellerFilter;
